import { Component } from '@angular/core';
import { finalize } from 'rxjs';
import { MatDialog } from '@angular/material/dialog';
import { BaseTableComponent } from '../../shared/base/base-table.component';
import { TPA_RRE } from '../../models/tpa-rre-management.model';
import { TpaRreManagementService } from '../../services/tpa-rre-management.service';
import { formatHttpErrorMessage } from '../../shared/utils/error.utils';
import { resolveLastUpdatedBy } from '../../shared/utils/user.utils';
import { TpaRreManagementModalComponent } from './tpa-rre-management-modal/tpa-rre-management-modal.component';

@Component({
  selector: 'app-tparremanagement',
  standalone: false,
  templateUrl: './tparremanagement.component.html',
  styleUrl: './tparremanagement.component.css',
})
export class TpaRreManagementComponent extends BaseTableComponent<TPA_RRE> {
  readonly displayedColumns: string[] = [
    'rre',
    'reportingGroup',
    'rreName',
    'responseMonitoringOn',
    'submissionAgent',
    'productionDate',
    'isocpAccountDesigneeOnly',
    'comment',
    'lastUpdatedBy',
    'lastUpdated',
    'actions',
  ];
  readonly pageSizes = [10, 20, 50];
  override sortBy = 'rre';
  override sortDir: 'asc' | 'desc' = 'asc';

  constructor(
    private tpaRreManagementService: TpaRreManagementService,
    private dialog: MatDialog
  ) {
    super();
  }

  protected override loadData(skip: number, count: number): void {
    this.loading = true;
    this.errorMessage = '';

    this.tpaRreManagementService.getTPA_RREs(this.sortBy, this.sortDir, this.searchTerm, skip, count)
      .pipe(finalize(() => (this.loading = false)))
      .subscribe({
        next: (result) => {
          this.dataSource.data = result.tpas ?? [];
          this.totalCount = result?.totalCount ?? 0;
        },
        error: (error) => {
          this.errorMessage = formatHttpErrorMessage('Failed to load TPA RRE records', error);
          this.dataSource.data = [];
          this.totalCount = 0;
        },
      });
  }

  addTPA_RRE(): void {
    const dialogRef = this.dialog.open(TpaRreManagementModalComponent, {
      width: '560px',
      maxWidth: '95vw',
      disableClose: true,
      restoreFocus: false,
      data: { isEdit: false },
    });

    dialogRef.afterClosed().subscribe((payload?: TPA_RRE) => {
      if (!payload) return;

      const requestPayload: TPA_RRE = {
        ...payload,
        LastUpdatedBy: resolveLastUpdatedBy(),
      };

      this.loading = true;
      this.errorMessage = '';
      this.tpaRreManagementService
        .addTPA_RRE(requestPayload)
        .pipe(finalize(() => (this.loading = false)))
        .subscribe({
          next: () => this.loadDataWrapper(),
          error: (error) => {
            this.errorMessage = formatHttpErrorMessage('Failed to add TPA RRE record', error);
          },
        });
    });
  }

  editTPA_RRE(record: TPA_RRE): void {
    const dialogRef = this.dialog.open(TpaRreManagementModalComponent, {
      width: '560px',
      maxWidth: '95vw',
      disableClose: true,
      restoreFocus: false,
      data: { isEdit: true, record },
    });

    dialogRef.afterClosed().subscribe((payload?: TPA_RRE) => {
      if (!payload) return;

      const requestPayload: TPA_RRE = {
        ...payload,
        LastUpdatedBy: resolveLastUpdatedBy(),
      };

      this.loading = true;
      this.errorMessage = '';
      this.tpaRreManagementService
        .updateTPA_RRE(requestPayload)
        .pipe(finalize(() => (this.loading = false)))
        .subscribe({
          next: () => this.loadDataWrapper(),
          error: (error) => {
            this.errorMessage = formatHttpErrorMessage('Failed to update TPA RRE record', error);
          },
        });
    });
  }
}
